module.exports = __webpack_public_path__ + "static/img/jgjf.b094f7c6.png";